import { delay, isLocalhostEnvironment, isPageVisible } from './utils';
const PRE_DELAY_MS = isLocalhostEnvironment() ? 2000 : 60000;
// SINGLETON ALERT!
const FPS_SAMPLES = [];
// SINGLETON ALERT!
// only allow one sampling at a time
let isFpsSamplingActive = false;
function maybeLog(msg) {
    if (!isLocalhostEnvironment()) {
        return;
    }
    console.log(msg);
}
/**
 * Measures and returns an FPS sample, after waiting a "pre-delay" to ensure things have settled after changing scenes.
 * Sampling is aborted if the page is not visible at the beginning or end of the sampling period.
 */
export async function getFpsSample() {
    if (isFpsSamplingActive) {
        return null;
    }
    isFpsSamplingActive = true;
    maybeLog(`[getFpsSample] waiting pre-delay ${PRE_DELAY_MS.toLocaleString()}ms`);
    await delay(PRE_DELAY_MS);
    if (!isPageVisible()) {
        maybeLog('[getFpsSample] aborting before FPS sampling, page is not visible...');
        isFpsSamplingActive = false;
        return null;
    }
    let isDone = false;
    let frameCount = 0;
    function handleFrame() {
        if (isDone) {
            maybeLog('[getFpsSample] stopping...');
            return;
        }
        frameCount++;
        requestAnimationFrame(handleFrame);
    }
    // get it started:
    maybeLog('[getFpsSample] starting sampling...');
    requestAnimationFrame(handleFrame);
    // hold up (wait a sec):
    await delay(1000);
    if (!isPageVisible()) {
        maybeLog('[getFpsSample] aborting after FPS sampling, page is not visible...');
        isDone = true;
        isFpsSamplingActive = false;
        return null;
    }
    maybeLog(`[getFpsSample] done sampling: ${frameCount} FPS`);
    isDone = true;
    isFpsSamplingActive = false;
    return frameCount;
}
export function addFpsSample(fps) {
    FPS_SAMPLES.push(fps);
    if (isLocalhostEnvironment()) {
        const fpsStats = getFpsStats();
        if (fpsStats) {
            maybeLog(`[addFpsSample] added ${fps} FPS, all samples: ${JSON.stringify(fpsStats.fpsSamples)}, total num samples: ${fpsStats.fpsSamples.length}, average: ${fpsStats.averageFps} FPS`);
        }
    }
}
export function getFpsStats() {
    if (!FPS_SAMPLES.length) {
        return;
    }
    const averageFps = Math.round(FPS_SAMPLES.reduce((acc, curr) => acc + curr) / FPS_SAMPLES.length);
    return { fpsSamples: [...FPS_SAMPLES], averageFps };
}
